export interface HomeHeroReadiness {
  loading: boolean;
  playable: boolean;
}

/**
 * Only authoritative table loading/validation may block PLAY. Asset/audio
 * warmup is intentionally absent from this contract so a slow optional preload
 * cannot recreate a startup gate after the engine has become usable.
 */
export function homeHeroPlayBlocked({ loading, playable }: HomeHeroReadiness): boolean {
  return loading || !playable;
}
